import { render, staticRenderFns } from "./KusBaseTopbar.vue?vue&type=template&id=312985b7"
import script from "./KusBaseTopbar.vue?vue&type=script&lang=js"
export * from "./KusBaseTopbar.vue?vue&type=script&lang=js"
import style0 from "./KusBaseTopbar.vue?vue&type=style&index=0&id=312985b7&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports